export default {
  isLoading: false,
  teams: [],
  team: {
    id: '',
    name: '',
  },
  userId: '',
};
